import React from "react";
import {categoryModuleService, moduleService} from "../jwt/_services";

export const categoryModuleProvider = {
    getOptions,
    getItem,
};

async function getOptions(){
    try {
        const listItems = await categoryModuleService.search(0, 1000, {});

        return listItems?.data?.map((itemData) => {
            const { id, name } = itemData
            return (
                {
                    id: id,
                    value: name,
                    label: <div><label>{name}</label></div>}
            )
        });
    } catch (error) {
       console.log(error.message)
    }
}

async function getItem(id){
    try {
        const item = await categoryModuleService.getItem(id);

        return (
            {
                id: item.id,
                value: item.name,
                label: <div><label>{item.name}</label></div>}
        );
    } catch (error) {
        console.log(error.message)
    }
}